// Third party modules;
import { createContext } from 'react';

// HelpBot modules;
import api from './api/api';
import LogOut from './LogOut';
import { FLOW } from './Flow';

const app = {

   body: (body) => {
      const common = { 
         application_slug: app.state.user_access_list[app.state.user_access_id].application_name.toLowerCase(), 
         //access_token: null, 
         session_id: 0
      };
      const return_value = ('undefined' === typeof body) ? common : Object.assign(common, body);
      // console.log('app.body:typeof body=' + (typeof body), JSON.stringify(return_value, null, 3));
      return return_value;
   }, // body();

   host: null,

   host_api: null, 

   Init: async (set_state) => {

      // Get the API target given the host from the current browser URL;
      const url = new URL(window.location.href);

      app.host   = url.protocol + '//' + url.hostname;

      app.prefix = url.pathname.slice(0, -6);

      if ('localhost' === url.hostname) {
         app.platform = ' : LOCAL';
      } else {
         app.host += '/help';
         if ('dev-' === url.hostname.substr(0, 4)) {
            app.platform  = ' : DEV';
         } else if ('test-' === url.hostname.substr(0, 5)) {
            app.platform  = ' : TEST';
         }
      }

      //app.host = "http://localhost:8050"
      app.host_api  = app.host + '/api/';

      app.set_state = (key, value, update_state) => {

         if ('undefined' === typeof update_state) update_state = true;

         if (('undefined' !== typeof key) && ('undefined' !== typeof value)) {

            switch (key) {
            case 'access_token'    : app.state.access_token     = value; break;
            case 'application_id'  : app.state.application_id   = value; break;
            case 'application_list': app.state.application_list = value; break;
            case 'login_message'   : app.state.login_message    = value; break;
            case 'mode'            : app.state.mode             = value; break;
            case 'name'            : app.state.name             = value; break;
            case 'name_full'       : app.state.name_full        = value; break;
            case 'status'          : app.state.status           = value; break;
            case 'user_access_id'  : 
               app.state.user_access_id = Number(value);
               app.state.application_id = app.state.user_access_list[app.state.user_access_id].application_id;
               app.state.version_id     = app.state.user_access_list[app.state.user_access_id].version_id;
               break;
            case 'user_access_list': app.state.user_access_list = value; break;
            case 'user_id'         : app.state.user_id          = value; break;
            case 'user_name'       : app.state.user_name        = value; break;
            case 'version_id'      : app.state.version_id       = value; break;
            case 'version_list'    : app.state.version_list     = value; break;
            default: console.log('app.set_state:key=', key, 'value=', value);
            }

         }

         if (update_state) {

            app.state_string = JSON.stringify(app.state);

            set_state(app.state_string);

            localStorage.setItem(app.storage, app.state_string);

         }

      }

      app.state_string = localStorage.getItem(app.storage);

      if (app.state_string) {

         app.state = JSON.parse(app.state_string);

      } else {

         app.state_string = JSON.stringify(app.state);

         localStorage.setItem(app.storage, app.state_string);

      }

      api.process_data = app.process_data;

   }, // Init();

   name: 'Research HelpBot',

   menu: [
      {
         label: 'API',
         items: [],
         prefix: 'ask-henry-menu-app-drop',
      },
      {
         label: 'Application',
         items: [
            'Integrate Application', 
            'Set Version',
         ],
         prefix: 'ask-henry-menu-app-drop',
         style: {width:'175px'},
      },
      {
         label: 'Knowledge', 
         items: [
            'Edit Intent', 
            'Delete Intents', 
            'Upload Intents', 
            'Edit Topic Tree', 
            'Upload Topic Tree',
            'Download Topic Tree',
         ],
         prefix: 'ask-henry-menu-app-drop',
         style: {width:'175px'},
      },
      {
         label: 'Report',
         items: [
            'Sessions',
         ],
         prefix: 'ask-henry-menu-app-drop',
         style: {width:'175px'},
      },
      {
         label: 'Test',
         items: [
            'Reply Search',
         ],
         prefix: 'ask-henry-menu-app-drop',
         style: {width:'175px'},
      },
      {
         label: 'User',
         items: [
            'Change Password',
            'Log Out',
         ],
         prefix: 'ask-henry-menu-app-drop',
         style: {marginLeft:'-50px', width:'175px'},
      },
      {  // This isn't displayed, it is only to load the components;
         label: 'dummy',
         items: [
            'Expired Password',
            'Log In',
         ],
      },
   ],

   platform: null, 

   process_data: (response) => {

      if (FLOW.GOOD !== response.data.flow) {
         if (response.data && response.data.text) {
            if ('Signature has expired' === response.data.text) {
               LogOut('The access token has expired, please login again.');  
            }
         }
      }

   }, // process_data();

   state: {
      access_token     : '',
      application_id   : 0,
      application_list : [],
      is_admin         : false,
      login_message    : '',
      mode             : '',
      name             : '',
      role             : '',
      user_access_id   : 0,
      user_access_list : [{ application_id: 0, version_id: 0 }],
      user_id          : 0,
      user_name        : '',
      version_id       : 1,
      version_list     : []
   },

   state_context: createContext(),

   state_string: '',

   storage: 'ask-henry-admin',

   version_api: null,

   version_bot: '0.7.4 built 2025-02-04 10:15:00',

   who: () => {
      var id   = app.state?.user_access_list[app.state?.user_access_id]?.version_id;
      var name = app.state?.user_access_list[app.state?.user_access_id]?.application_name;
      return ' : ' + name + '(' + id + ')';
   }

}

export default app;
